export default __webpack_public_path__ + "4ebb4466073112cf3d319c9ba19addfa.webp";